<template>
      <v-dialog persistent value="true" max-width="300">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
          <v-card-text>{{ question }}</v-card-text>
          <v-card-actions>
           <v-btn flat="flat" @click="$error(false)">Non</v-btn>
           <v-spacer></v-spacer>
           <v-btn color="primary" @click="$close(true)">Oui</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  props: {
    question: String,
  },
}
</script>
